import {useTranslation} from "react-i18next";
import Cookies from "js-cookie";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {
    GetListStatusZone,
    UpdateZone, ZoneDetailChildV1,
} from "../../../../reduxToolkit/EmployeeZones/EmployeeZonesApi";
import {toast} from "react-toastify";
import {errorMsg} from "../../../../Apis/functions";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const SingleZoneUpdateApp = () => {

    // translation
    const { t } = useTranslation();
    const lCode = Cookies.get('i18next') || 'en';
    const params = useParams();
    const { id } = params;
    // use hook importer
    const dispatch = useDispatch();
    // use State hook for local state management
    const [name, setName] = useState('');
    const [isStatus, setIsStatus] = useState('');
    const [formDate, setFormDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [isCommonArea, setIsCommonArea] = useState(false);
    //use Selector hook to get state for redux store
    const { zoneDetailChildV1 } = useSelector((state) => state.EmployeeZonesSlice);
    const { getListStatusZone } = useSelector((state) => state.EmployeeZonesSlice);
    const [emptyFields, setEmptyFields] = useState(false)
    const [isValidHour, setIsValidHour] = useState(true)

    useEffect(() => {
        dispatch(GetListStatusZone());
        if (id !== null && typeof id !== "undefined"){
            getData();
        }
    }, [id,dispatch]);

    const getData = () => {
        dispatch(ZoneDetailChildV1({ zoneId: id })).then(({payload: {data: { success ,data},},}) => {
                if (success === true) {
                    setIsCommonArea(data?.commonArea?.id || false)
                    setName(data?.name || '');
                    setIsStatus(data?.statusId || '');
                    setFormDate(data?.commonArea?.from ? new Date(`2014-08-01T${data?.commonArea?.from}`) : null);
                    setToDate(data?.commonArea?.to ? new Date(`2014-08-01T${data?.commonArea?.to}`) : null);
                }
            },
        );
    }

    const updateZoneHandler = () => {
        const pad = (num) => String(num).padStart(2, '0');

        const body = {
            id: zoneDetailChildV1?.id,
            name: name,
            statusId: isStatus,
            fatherId: zoneDetailChildV1?.fatherId ?? null,
            latitud: zoneDetailChildV1?.latitud ?? null,
            longitud: zoneDetailChildV1?.longitud ?? null,
            commonArea: isCommonArea
                ? {
                    id: zoneDetailChildV1?.commonArea?.id ?? null,
                    from: formDate
                        ? `${pad(formDate.getHours())}:${pad(formDate.getMinutes())}:${pad(formDate.getSeconds())}`
                        : null,
                    to: toDate
                        ? `${pad(toDate.getHours())}:${pad(toDate.getMinutes())}:${pad(toDate.getSeconds())}`
                        : null,
                }
                : null,
        };

        dispatch(UpdateZone(body)).then(
            ({ payload: { data: { success,code } } }) => {
                if (success === true) {
                    getData();
                    toast.success(t('has_been_updated_successfully'));
                }else errorMsg(code)
            }
        );
    };

    const handleUpdate = () => {
        const zoneValid = name !== '' && isStatus !== '';
        if (!zoneValid || (isCommonArea && (!formDate || !toDate))) {
            setEmptyFields(true);
            return;
        }

        setEmptyFields(false);
        const areaValid = !isCommonArea || (
            formDate instanceof Date && !isNaN(formDate) &&
            toDate instanceof Date && !isNaN(toDate)
        );
        const validMinutes = (date) => date.getMinutes() % 30 === 0;

        const isIntervalValid = !isCommonArea || (validMinutes(formDate) && validMinutes(toDate) && formDate < toDate);
        if (!areaValid || !isIntervalValid) {
            setIsValidHour(isIntervalValid);
            if (!isIntervalValid) {
                 toast.error(t('please_select_valid_x_min_intervals', { intervals: 30 }));
            }
            return;
        }
        setIsValidHour(true);
        updateZoneHandler();
    };


    useEffect(()=>{
        if (!isCommonArea){
            setFormDate(new Date(0));
            setToDate(new Date(0));
        }
    },[isCommonArea])

    return {
        t,name,setName,lCode,isStatus,setIsStatus,getListStatusZone,isCommonArea,setIsCommonArea,
        formDate,setFormDate,toDate,setToDate,handleUpdate,emptyFields,id, isValidHour
    }
}
